import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {HtmlParse, slugify} from 'utils';
import ProductFactory from 'factories/Products';
import TagManagerService from 'services/TagManager';
import PubSub from 'services/PubSub/';
import BreadCrumb from 'components/BreadCrumb';
import ProductControls from 'components/ProductControls';
import ProductPrices from "components/ProductPrices";
import Metas from 'components/Metas';
import Description from "components/Product/Description";
import Gallery from "components/Product/Gallery";
import Loader from "components/Loader";
import TechnicalTable from 'components/Product/TechnicalTable';
import ProductFlags from 'components/ProductFlags';
import NutritionalTable from 'components/Product/NutritionalTable';
import ModalFoodCertificates from 'components/Product/ModalFoodCertificates';
import ShopTogether from 'components/Product/ShopTogether';
import NewShopTogether from 'components/Product/NewShopTogether';
import Average from 'components/Reviews/Average';
import ReviewsContainer from 'components/Reviews/ReviewsContainer'
import ProductSimilar from 'components/Product/SimilarProduct'
import FavoriteButton from 'components/FavoriteButton';
import Items from './ModalFoodCertificates/Items';
import ModalShopTogether from './ShopTogether/ModalShopTogether';
import {translateFlag, actionsType, ecommerce} from 'config/constants';
import { features, shopTogetherID } from 'config'
import StorageService from 'services/StorageService';
import WrapperOptimizer from 'components/WrapperOptimizer';
import useVariant  from 'hooks/useVariant';
import { withRouter } from "react-router";
import { useViewportMediaQuery } from 'hooks'
import style from './style.scss'; //NOSONAR
import CountriesFlag from 'components/CountriesFlag';

let actions = [];
let technical = "";
let idProduct = null;
let idCategory = null;

const Product = (props) => {
    const [inCart, setInCart] = useState(0);

    const { product, isLoaded } = props;
    const item = product ? product.items[0] : null;
    const skuData = (product && product.SkuData && product.SkuData[item.itemId]) ? product.SkuData[item.itemId] : {};
    const complementName = product ? product.items[0].complementName : null;
    const title = product ? product.productTitle || `${product.productName} | ${ecommerce.metaTitle}` : '';
    const description = product ? product.metaTagDescription || title : '';
    idProduct = item ? item.itemId : null;
    let categoriesIds = product && product.categoriesIds && product.categoriesIds.length && product.categoriesIds[0].split('/').filter(Boolean).slice(-1).pop();
    idCategory = categoriesIds;

    const variant = useVariant(shopTogetherID);

    const isMobile = useViewportMediaQuery(1024);

    useEffect(() => {
        if (!hasStockProduct && isLoaded && item) {
            let storeName = StorageService.getItem("store_name");
            if (!storeName) {
                storeName = "Jumbo Chile"
            }
            TagManagerService.productWithoutStock(storeName + " - PDP", item.itemId, item.name);
        }
    }, [item]);

    let controlsConfig = item ? {
        unitMultiplier: item.unitMultiplier,
        measurementUnit: item.measurementUnit,
        unitSale: (product['Pesable x Unidad'] && product['Pesable x Unidad'][0]) ? translateFlag[product['Pesable x Unidad'][0]] : false,
        maxItems: (item.maxItems) - inCart,
        maxItemsOrigin: (item.maxItems),
        buyTitle: "Agregar",
        listTitle: 'Guardar en una lista',
        listButton: true,
        tagManagerData: { product: product, listTitle: 'PDP' },
        addToCartCallback: (quantity) => {
            TagManagerService.addToCart(product, quantity, 'PDP' );
        }
    } : {};

    let pricesSettings = {
        promotionDescription: true
    };

    useEffect(() => {
        actions.push(PubSub.register('cart_update', _updateInCart));
        if (!product && isLoaded) {
            const search = window.location.pathname.replace('/', '').replace('/p', '');
            props.history.push(`/Sistema/404?ProductLinkNotFound=${search}`);
        }

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
            idProduct = null;
            idCategory = null;
        };
    }, []);

    useEffect(() => {
        if (product && isLoaded) {
            setTimeout(() => PubSub.dispatch('product_scroll', { product }), 0);
            _updateInCart();
        }

        if (typeof window !== 'undefined' && !product && isLoaded) {
            const search = window.location.pathname.replace('/', '').replace('/p', '');
            props.history.push(`/Sistema/404?ProductLinkNotFound=${search}`);
        }
    }, [product, isLoaded]);

    const getCrumbs = () => {
        if (!product) return [];

        const categories = product.categories.map((category) => {
            return category.split('/').filter(String);
        }).reverse();
        return categories.map((cat) => {
            return {
                title: cat.slice(-1).pop(),
                url: `/${cat.map((category) => {
                    return slugify(category)
                }).join("/")}/`
            }
        });
    }

    const _updateInCart = () => {
        if (!(typeof window !== 'undefined' && window.orderItems && idProduct)) return false;
        const itemData = window.orderItems[idProduct];
        const quantity = itemData ? itemData.quantity : 0;

        setInCart(quantity);
    }

    const hasStock = (itemData) => {
        if (!itemData) return false;
        const commertialOffer = (itemData.sellers && itemData.sellers[0]) ? itemData.sellers[0].commertialOffer : false;
        return !!(commertialOffer && commertialOffer.ListPrice !== 0 && commertialOffer.AvailableQuantity && commertialOffer.AvailableQuantity > 0);
    }

    const _openFoodCertificates = () => {
        PubSub.dispatch(actionsType.MODAL.FOOD_CERTIFICATES_OPEN, { 'product': product });
    }

    const goToBrand = (brand) => {
        const formatBrand = slugify(brand);
        props.history.push(`/${formatBrand}`);
        TagManagerService.interaction("Click Marca", brand, product?.categories[0]);
    }

    const hasStockProduct = hasStock(item);
    const crumbs = getCrumbs();

    if (item) {
        item.sellerId = item.sellers[0] ? item.sellers[0].sellerId : null;
    }

    const unitMeasurement = item ? ProductFactory.formatWeight(item.measurementUnit, item.unitMultiplier) : '';
    let foodCertificate = product && product['Condiciones Alimentarias'] ? product['Condiciones Alimentarias'] : [];
    const organicCertificate = product && product['Elaboración'] && (product['Elaboración'][0] === 'Orgánico') ? product['Elaboración'][0] : null;
    const exclusiveJumbo = product && product['Exclusivo Jumbo'] && (product['Exclusivo Jumbo'][0] === 'Sí') ? product['Exclusivo Jumbo'][0] : null;
    const countryFlag = product && product['Origen'] && (product['Origen'][0] === 'EEUU') ? product['Origen'][0] : null
    const ShopTogetherVariant = !variant || variant == '0' ? ShopTogether : NewShopTogether;

    if (organicCertificate && foodCertificate) {
        foodCertificate.push(organicCertificate);
    }

    return (
        <>
            {product && isLoaded && <Metas>
                <title>{title}</title>
                <meta name="description" content={description}/>
                <meta name="Abstract" content={description}/>
                <meta property="og:url" content={typeof window !== 'undefined' ? window.location.href : ''}/>
                <meta property="og:title" content={product.productName}/>
                <meta property="og:description" content={(product.brand + ' | ' + 'Código de producto: ' + product.productReference)}/>
                <meta property="og:image" content={(item && item.images && item.images[0]) ? item.images[0].imageUrl : "https://www.jumbo.cl/uploads/2019/04/logoJumbo.jpeg"}/>
                <meta property="og:type" content="article"/>
                <meta property="fb:app_id" content="30408486720"/>
                <meta name="twitter:card" content="summary"/>
                <meta name="twitter:site" content="@JumboChile"/>
                <meta name="twitter:title" content={product.productName}/>
                <meta name="twitter:description" content={(product.brand + ' | ' + 'Código de producto: ' + product.productReference)}/>
                <meta name="twitter:image" content={(item && item.images && item.images[0]) ? item.images[0].imageUrl : "https://www.jumbo.cl/uploads/2019/04/logoJumbo.jpeg"}/>
            </Metas>}

            {!product && <Loader className={'product-page-loader'}/>}
            {product && <div className="container">
                <BreadCrumb crumbs={crumbs}/>
                <main className="product-content">
                    <div className="product-info">
                        <div className="product-image-container">
                            {idProduct && <FavoriteButton sku={idProduct} position={0} type={'tooltip_favorite_pdp'}/>}
                            <div className={'product-image-wrapper'}>
                                <Gallery images={item.images}/>
                            </div>
                        </div>
                        <div className="product-info-wrapper">
                            <ProductFlags exclusiveJumbo={exclusiveJumbo} item={item} stock={hasStockProduct}/>
                            <div className="product-container-title">
                                <h1 className={'product-name'}>{product.productName}</h1>
                            </div>
                            <div className="product-aditional-info">
                                <div className="aditional-info">
                                    <span className="product-single-unit">{unitMeasurement}</span>
                                    <a className="product-brand" onClick={(()=> goToBrand(product?.brand))}>{product.brand}</a>
                                </div>
                                <div className="aditional-info">
                                    <span className="product-code">Código: {product.productReference}</span>
                                </div>
                            </div>
                            {product && product.productId && <Average comment={true} productId={product.productId} itemId={idProduct}/>}
                            {hasStockProduct && <ProductPrices item={item} skuData={skuData} settings={pricesSettings} productDetail={true}/>}
                            {(complementName || foodCertificate) && <div className="product-main-description">
                                {foodCertificate && !!foodCertificate.length && <div className="product-certificates-title-wrap">
                                    <span
                                        className="product-certificates-title">Certificados</span>
                                    {(foodCertificate && foodCertificate.length >= 5) &&
                                    <button className="product-certificates-button" onClick={() => _openFoodCertificates()}>Ver todos</button>}
                                </div>}
                                {foodCertificate && !!foodCertificate.length && isMobile &&
                                <Items items={foodCertificate}/>}
                                {foodCertificate && !!foodCertificate.length && !isMobile &&
                                <Items items={foodCertificate.slice(0, 5)}/>}
                                {complementName && <div className="product-main-description-title-wrap">
                                    <span className="product-main-description-title">Características principales</span>
                                </div>}
                                <CountriesFlag countryFlag={countryFlag}/>          
                                {complementName && <span className="product-main-description-short">{HtmlParse(complementName)}</span>}
                            </div>}
                            {hasStockProduct &&
                            <ProductControls item={item} id={item.itemId} seller={item.sellerId} config={controlsConfig} quantity={item.quantity} inCart={item.inCart} pageSource={'PDP'} exclusiveJumbo={exclusiveJumbo}/>}
                            {!hasStockProduct && <div className={'no-stock'}>
                                <i className={'font-icn alert'}/>
                                <span className={'no-stock-text'}>En estos momentos, este artículo se encuentra sin stock.</span>
                            </div>}
                        </div>
                    </div>

                    {(features.personalize && idProduct && hasStockProduct) &&
                    <WrapperOptimizer typeComponent="pdp_shop_together_dynamic" categoryIds={product.categoriesIds}>
                        {(data) => <ShopTogetherVariant skuId={idProduct} currentProd={product} campaignData={data} categoryIds={product.categoriesIds} variant={variant} />}
                    </WrapperOptimizer>}
                    {(!hasStockProduct) ? (<div
                        className={'product-wrap-section ' + (!(product && (product['Información Nutricional (por 100 g / por porción)'] || product['Ficha Técnica'])) ? 'not-nutricionalContent' : 'activeNutricional')}>
                        {features.personalize && idProduct && <WrapperOptimizer typeComponent="pdp_similar_products">
                            {(data) => <ProductSimilar skuId={idProduct} categoryId={idCategory} type={'category'} campaignData={data}/>}
                        </WrapperOptimizer>}
                        {<ReviewsContainer product={product} />}
                        <Description product={product} technical={technical}/>
                    </div>) : <div
                        className={'product-wrap-section ' + (!(product && (product['Información Nutricional (por 100 g / por porción)'] || product['Ficha Técnica'])) ? 'not-nutricionalContent' : 'activeNutricional')}>
                        <Description product={product} technical={technical}/>
                        {features.personalize && idProduct && <WrapperOptimizer typeComponent="pdp_similar_products">
                            {(data) => <ProductSimilar skuId={idProduct} categoryId={idCategory} type={'category'} campaignData={data}/>}
                        </WrapperOptimizer>}
                        {<ReviewsContainer product={product} />}
                    </div>}
                    <div className="product-wrap-table">
                        <TechnicalTable product={product}/>
                        <NutritionalTable product={product}/>
                    </div>
                </main>
                <ModalFoodCertificates/>
                <ModalShopTogether/>
            </div>}
        </>
    )
}

Product.propTypes = {
    product: PropTypes.object,
    history: PropTypes.object,
    isLoaded: PropTypes.bool
};

export default withRouter(Product);
